import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { installWalletExtensionNoiseHandlers } from './utils/walletExtensionNoise';

installWalletExtensionNoiseHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
  </BrowserRouter >
);
reportWebVitals();
